import { DEFAULT_IMAGE_SETTINGS, ImageSizeMode } from '@domain/image';
import { aspectRatioScale } from '@studio/utils/geom';
import { clamp, toFixedDecimal } from '@studio/utils/utils';
export function deserializeImageSettings(element, originalSize) {
    if (isMigratedImageSetting(element.imageSettings)) {
        return Object.assign(Object.assign({}, element.imageSettings), { sizeMode: element.imageSettings.sizeMode });
    }
    const migratedImageSettings = migrateFitToImageSettings(element, originalSize);
    return Object.assign(Object.assign({}, migratedImageSettings), { sizeMode: migratedImageSettings.sizeMode });
}
function isMigratedImageSetting(imageSettings) {
    if (!imageSettings) {
        return false;
    }
    const { x, y } = imageSettings;
    return x >= 0 && x <= 1 && y >= 0 && y <= 1;
}
export function serializeImageSettings(settings) {
    return Object.assign({}, settings);
}
function migrateFitToImageSettings(element, originalSize = {}) {
    var _a;
    // Feeds do not have an image asset
    if (!originalSize.width || !originalSize.height) {
        originalSize.width = element.width;
        originalSize.height = element.height;
    }
    const settings = Object.assign(Object.assign(Object.assign({}, element.imageSettings), { sizeMode: fitOptionToSizeMode((_a = element.imageSettings) === null || _a === void 0 ? void 0 : _a.sizeMode) }), getFitPositionAsFractionAlign(element, originalSize));
    return settings;
}
/**
 * Translates fitPositionX/Y to an align
 */
export function getFitPositionAsFractionAlign(element, originalSize) {
    let x = 0.5;
    let y = 0.5;
    const imageSettings = element.imageSettings;
    const fitOption = imageSettings === null || imageSettings === void 0 ? void 0 : imageSettings.sizeMode;
    const fitPositionX = Number((imageSettings === null || imageSettings === void 0 ? void 0 : imageSettings.x) || 0);
    const fitPositionY = Number((imageSettings === null || imageSettings === void 0 ? void 0 : imageSettings.y) || 0);
    // fitPosition only applies to cover. Contain is not supported yet
    if (fitOption === 'crop' && (originalSize === null || originalSize === void 0 ? void 0 : originalSize.width) && (originalSize === null || originalSize === void 0 ? void 0 : originalSize.height)) {
        const renderedImageSize = aspectRatioScale(originalSize, element, 'cover');
        const overflowX = renderedImageSize.width - element.width;
        if (fitPositionX && overflowX > 0) {
            // fitPositionX = -1 means that we move the image 0.5px left
            x = toFixedDecimal(clamp(0.5 - (fitPositionX * 0.5) / overflowX, 0, 1));
        }
        const overflowY = renderedImageSize.height - element.height;
        if (fitPositionY && overflowY > 0) {
            // fitPositionY = -1 means that we move the image 0.5px up
            y = toFixedDecimal(clamp(0.5 - (fitPositionY * 0.5) / overflowY, 0, 1));
        }
    }
    return {
        x,
        y
    };
}
export function fitOptionToSizeMode(fitOption) {
    switch (fitOption) {
        case 'cover':
        case 'crop':
            return ImageSizeMode.Crop;
        case 'distort':
        case 'stretch':
            return ImageSizeMode.Stretch;
        case 'contain':
        case 'fit':
            return ImageSizeMode.Fit;
        default:
            return DEFAULT_IMAGE_SETTINGS.sizeMode;
    }
}
